import { useCallback, useEffect, useMemo, useState } from "react";
import {
  AUTHORIZATION_EXPORT_INITIAL_FORM,
  buildAuthorizationExportErrors,
  getTouchedAuthorizationExportFields,
  normalizeAuthorizationExportValue,
} from "../utils/authorizationExportForm";

export const useAuthorizationExportForm = ({ isOpen, onSubmit }) => {
  const [formValues, setFormValues] = useState(
    AUTHORIZATION_EXPORT_INITIAL_FORM,
  );
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (isOpen) {
      setFormValues(AUTHORIZATION_EXPORT_INITIAL_FORM);
      setTouched({});
    }
  }, [isOpen]);

  const errors = useMemo(
    () => buildAuthorizationExportErrors(formValues),
    [formValues],
  );
  const hasErrors = useMemo(
    () => Object.values(errors).some(Boolean),
    [errors],
  );

  const handleChange = useCallback((field, value) => {
    setFormValues((prev) => ({
      ...prev,
      [field]: normalizeAuthorizationExportValue(field, value),
    }));
  }, []);

  const handleBlur = useCallback((field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  }, []);

  const handleSubmit = useCallback(async () => {
    setTouched(getTouchedAuthorizationExportFields());

    if (hasErrors) return false;

    const result = await onSubmit(formValues);
    return result !== false;
  }, [formValues, hasErrors, onSubmit]);

  return {
    errors,
    formValues,
    hasErrors,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
  };
};
